export const seleneMainInteractions = [
    {
        id: 1,
        label: 'Talk',
        disabled: false
    },
    {
        id: 2,
        label: '(Interact...)',
        disabled: true
    }
]
